export default "__VITE_ASSET__2f7a1377__"